import { CSSTransition } from "react-transition-group";

import { cx } from "@/utils";

import styles from "../TopWidgets.module.css";

const Card: React.FunctionComponent<
  { loading?: boolean } & React.DetailedHTMLProps<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  >
> = ({ children, className, loading, ...props }) => (
  <button type="button" className={cx(styles.card, className)} {...props}>
    <CSSTransition
      in={!loading}
      timeout={500}
      classNames={{
        enter: styles.loadingEnter,
        enterActive: styles.loadingEnterActive,
      }}
      unmountOnExit
    >
      <div className={styles.cardContent}>{!loading && children}</div>
    </CSSTransition>
  </button>
);

export default Card;
